var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import VTTimelineAddScene from "./VTTimelineAddScene";
import VTSidePanel from "./VTSidePanel";
import VTDragMedia from "./VTDragMedia";
import { Container } from "@mui/material";
import { useState } from "react";
export default function VTEmptyTimeline(_a) {
    var title = _a.title, _b = _a.anchor, anchor = _b === void 0 ? "bottom" : _b, sx = _a.sx;
    var _c = __read(useState(140), 2), drawWidth = _c[0], setDrawWidth = _c[1];
    return (
    //Create a container for the Side panel to be in
    //Create another container for the Add scene and drag media
    //------------------------------------------------------------------------------------------------------------------------------------------------
    //1 Flexbox make items start from the very left
    //2 Max height on the side panel
    //3 Create 10 scenes on item timeline and have it scroll sideways DONE
    //4 Scalable images when moving drag up DONE
    //5 Look at how theming works in storybook(Dark and Light Mode)
    //------------------------------------------------------------------------------------------------------------------------------------------------
    _jsx(VTSidePanel, __assign({ anchor: "bottom", currentDrawWidth: drawWidth, setCurrentDrawWidth: setDrawWidth, minDrawerWidth: 120, maxDrawerWidth: 200 }, { children: _jsxs(Container, __assign({ sx: { display: "flex", justifyContent: "flex-start" } }, { children: [_jsx(VTDragMedia, { sx: { padding: 2 } }), _jsx(VTTimelineAddScene, { sx: { padding: 2, width: "20%" }, size: 100 })] })) })));
}
